import React, { createContext, PropsWithChildren, useState } from 'react';

import { SearchFilterContentTypes } from '../../../Shared/enums';
import { SearchBarVariant } from './NavSearchElements/searchUtils';

export interface NavSearchProps {
  contentType: SearchFilterContentTypes;
  onSubmit: (event: string, value: string, searchOrigin: string) => void;
  userHasAnySubscription: boolean;
  fetchTypeahead: (
    contentType: SearchFilterContentTypes,
    query: string,
    typeaheadEnhancementExperiment: boolean
  ) => Promise<any>;
  isEnterpriseMember: boolean;
  pproPluginEnabled: boolean;
  isSearchAppLoaded: () => boolean;
  showSuggestions?: boolean;
  setShowSuggestions?(value: boolean): void;
  searchOrigin?: string;
  useSnapshots?: boolean;
  enableSearchHistory?: boolean;
  searchBarVariant?: SearchBarVariant;
  imagesUrl?: string;
}

export const NavSearchContext = createContext({} as NavSearchProps);

export function NavSearchContextProvider({
  children,
  ...props
}: PropsWithChildren<NavSearchProps>) {
  const [showSuggestions, setShowSuggestions] = useState(false);

  return (
    <NavSearchContext.Provider
      value={{
        ...props,
        showSuggestions,
        setShowSuggestions,
      }}
    >
      {children}
    </NavSearchContext.Provider>
  );
}
